<ng-container *ngIf="data$ | async as data">
	<h1 *ngIf="!routeData?.hideTitle" class="obg-content-title">{{ data.title }}</h1>
	<div
		*ngIf="!isAnchorsMenuEnabled else anchorLinksTemplate"
		test-id="content-description"
		[innerHtml]="data.description"
	></div>
	<ng-template #anchorLinksTemplate>
		<obg-content-section-group-container
			[hideBanner]="true"
			[document]="routeData?.document"
		></obg-content-section-group-container>
	</ng-template>
</ng-container>
